import { setIotData } from "../redux/BuildingSlice";

export function executeItemsCalls(dispatch, iotCalls) {
  for (const iot in iotCalls) {
    executeItemCall(iotCalls[iot])
      .then((data) => {
        dispatch(setIotData({ data, iot }));
      })
      .catch((e) => console.log(e));
  }
}

function executeItemCall(sitemap) {
  return new Promise(function (resolve, reject) {
    const httpRequest = new XMLHttpRequest();
    const { url } = sitemap;

    httpRequest.open("GET", url);
    httpRequest.setRequestHeader("Authorization", sitemap.headers.Authorization);

    httpRequest.onerror = function (err) {
      reject(err);
    };
    httpRequest.send();
    httpRequest.onreadystatechange = function () {
      if (this.status === 200) {
        if (this.readyState === 4) {
          const result = JSON.parse(httpRequest.responseText);
          resolve(result.map((e) => ({ ...e, id: e.name })));
        }
      } else {
        reject(this.status);
      }
    };
  });
}

export function executeItemCreate(sitemap, data) {
  return new Promise(function (resolve, reject) {
    const httpRequest = new XMLHttpRequest();
    const url = `${sitemap.url}/${data.name}`;

    httpRequest.open("PUT", url);
    httpRequest.setRequestHeader("accept", "application/json");
    httpRequest.setRequestHeader("Content-Type", "application/json");
    httpRequest.setRequestHeader("X-OPENHAB-TOKEN", sitemap.headers.xOpenhabToken);
    httpRequest.setRequestHeader("Authorization", sitemap.headers.Authorization);

    httpRequest.onerror = function (err) {
      reject(err);
    };
    httpRequest.send(JSON.stringify(data));
    httpRequest.onreadystatechange = function () {
      if (this.status === 200 || this.status === 201) {
        if (this.readyState === 4) {
          resolve(httpRequest.responseText);
        }
      } else {
        reject(httpRequest.status);
      }
    };
  });
}

export function executeItemDelete(sitemap, data) {
  return new Promise(function (resolve, reject) {
    const httpRequest = new XMLHttpRequest();
    const url = `${sitemap.url}/${data.name}`;

    httpRequest.open("DELETE", url);
    httpRequest.setRequestHeader("accept", "application/json");
    httpRequest.setRequestHeader("Content-Type", "application/json");
    httpRequest.setRequestHeader("X-OPENHAB-TOKEN", sitemap.headers.xOpenhabToken);
    httpRequest.setRequestHeader("Authorization", sitemap.headers.Authorization);

    httpRequest.onerror = function (err) {
      reject(err);
    };
    httpRequest.send(JSON.stringify(data));
    httpRequest.onreadystatechange = function () {
      if (this.status === 200 || this.status === 201) {
        if (this.readyState === 4) {
          resolve(httpRequest.responseText);
        }
      } else {
        reject(httpRequest.status);
      }
    };
  });
}
